import { AbstractControlOptions, AsyncValidatorFn, FormControl, FormGroup, ValidatorFn, Validators } from "@angular/forms";
import { BillingInformationType } from "@app/shared/enums/billing-information.type";
import { BillingInformationModel } from "@app/shared/models/billing-information/billing-information.model";
import { Constants } from "@app/shared/models/common/constants";
import CustomValidators from "@app/shared/validators/custom.validator";

export class BillingInformationFormGroup extends FormGroup {
    constructor(
        billingInformation: BillingInformationModel, 
        validatorOrOpts?: ValidatorFn | ValidatorFn[] | AbstractControlOptions | null, 
        asyncValidator?: AsyncValidatorFn | AsyncValidatorFn[] | null) {
        super({
            id: new FormControl<number>(billingInformation.id ?? 0),
            name: new FormControl<string>(billingInformation.name ?? '', [Validators.maxLength(100)]),
            sendInvoiceTo: new FormControl<BillingInformationType>(billingInformation.sendInvoiceTo ?? null),
            companyName: new FormControl<string>(billingInformation.companyName ?? '', [Validators.maxLength(100)]),
            countryId: new FormControl<number>(billingInformation.countryId ?? 0, CustomValidators.required),
            address: new FormControl<string>(billingInformation.address ?? '', [CustomValidators.required, Validators.maxLength(200)]),
            city: new FormControl<string>(billingInformation.city ?? '', [CustomValidators.required, Validators.maxLength(100)]),
            zipCode: new FormControl<string>(billingInformation.zipCode ?? '', [CustomValidators.required, Validators.maxLength(10)]),

            emailAddress: new FormControl<string>(billingInformation.emailAddress ?? '', [
                CustomValidators.required,
                Validators.email,
                Validators.pattern(Constants.EmailExpression),
            ]),

            vatNumber: new FormControl<string>(billingInformation.vatNumber ?? '', [Validators.maxLength(15)]),
            description: new FormControl<string>(billingInformation.description ?? '', [Validators.maxLength(100)]),
        }, validatorOrOpts, asyncValidator);
    }

    override controls!: {
        id: FormControl<number>;
        name: FormControl<string>;
        sendInvoiceTo: FormControl<BillingInformationType>;
        companyName: FormControl<string>;
        countryId: FormControl<number>;
        address: FormControl<string>;
        city: FormControl<string>;
        zipCode: FormControl<string>;
        emailAddress: FormControl<string>;
        vatNumber: FormControl<string>;
        description: FormControl<string>;
    };
}